module.exports = __webpack_public_path__ + "static/media/deals_red.0e2cfa73.svg";